import React from 'react';
import {Row, Col, Button} from "react-bootstrap";
import style from './Advisor.module.scss';
import OwlCarousel from 'react-owl-carousel';
import * as advisorActions from "../../../../redux/action/advisor.action";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {BASE_URL} from "../../../../environment/environment";
import * as urls from "../../../../config/urls";
import transactionTypes from '../../../../asset/data/transactionTypes';
import propertyTypes from '../../../../asset/data/propertyTypes';

class Advisor extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      options: {
          loop: true,
          margin: 10,
          nav:false,
          responsive:{
              0: {
                  items: 1,
              },
              600: {
                  items: 2,
              },
              1000: {
                  items: 4,
              },
          },
      },
      advisors: []
    }
  }

  async componentDidMount() {
    this.fetchTopAdvisor();
  }

  async fetchTopAdvisor() {
    try {
      const advisors = await this.props.fetchTopAdvisor();
      this.setState({advisors});
    } catch (e) { }
  }

  render() {
    const { advisors } = this.state;
    return (
        <div className={`${style.advisor_container}`}>
          <h2 className={'section-title'}>برترین مشاوران ما</h2>
          <Row>
            <Col>
              {
                advisors && !!advisors.length && (
                    <OwlCarousel className="owl-theme" {...this.state.options}>
                      {
                        advisors.map(advisor => {
                          return (
                              <div className={`${style.item}`} key={advisor.id}>
                                <div className={`${style.box} d-flex flex-column align-items-center`}>
                                  <div className={style.avatar}>
                                    {
                                      advisor.avatar ? (
                                          <img src={`${BASE_URL}${urls.FILE_BY_UUID}/${advisor.avatar}?size=thumbnails`} alt="profile" />
                                      ) : (
                                          <span className={`${style.no_user} d-flex justify-content-center align-items-center`}>
                                            <i className={'icon-avatar'} />
                                          </span>
                                      )
                                    }
                                  </div>
                                  <span className={`${style.name}`}>{advisor.alias || '---'}</span>
                                  <div className={`text-right ${style.content}`}>
                                    <div className={'d-flex align-items-center justify-content-start'}>
                                      <i className={'icon-avatar'} />
                                      <span className={style.key}>مشاوره: </span>
                                      <span className={style.value}>
                                        {
                                          advisor.adviseTypes && !!advisor.adviseTypes.length ? (
                                              advisor.adviseTypes.map((item, index) => {
                                                return (
                                                    index <= 1 &&
                                                    <span className={style.value}>
                                                      {transactionTypes.find((i) => i.value === item).label}
                                                      {
                                                        (index !== advisor.adviseTypes.length -1) && (
                                                            <span>،&nbsp;</span>
                                                        )
                                                      }
                                                  </span>
                                                )
                                              })
                                          ) : (
                                            <span className={style.value}>-</span>
                                          )
                                        }
                                        {
                                          advisor.adviseTypes && advisor.adviseTypes.length > 2 && (
                                              <span className={style.value}> ...</span>
                                          )
                                        }
                                      </span>
                                    </div>
                                    <div className={'mt-1 d-flex align-items-center justify-content-start'}>
                                      <i className={'icon-home'} />
                                      <span className={style.key}>فعالیت: </span>
                                      {
                                        advisor.activityTypes && !!advisor.activityTypes.length ? (
                                          advisor.activityTypes.map((item, index) => {
                                            return (
                                                index <= 1 &&
                                                  <span className={style.value}>
                                                    {propertyTypes.find((i) => i.value === item).label}
                                                    {
                                                      (index !== advisor.activityTypes.length -1) && (
                                                          <span>،&nbsp;</span>
                                                      )
                                                    }
                                                  </span>
                                            )
                                          })
                                        ) : (
                                          <span className={style.value}>-</span>
                                        )
                                      }
                                      {
                                        advisor.activityTypes && advisor.activityTypes.length > 2 && (
                                            <span className={style.value}> ...</span>
                                        )
                                      }
                                    </div>
                                    <div className={'mt-1 d-flex align-items-center justify-content-start'}>
                                      <i className={'icon-target'} />
                                      <span className={style.key}>محله: </span>
                                      {
                                        advisor.regions && !!advisor.regions.length ? (
                                            <React.Fragment>
                                              <span className={style.value}>{advisor.regions[0].title}</span>
                                              {
                                                advisor.regions.length > 1 && (
                                                    <span className={style.value}>، ...</span>
                                                )
                                              }
                                            </React.Fragment>
                                        ) : (
                                            <span className={style.value}>-</span>
                                        )
                                      }
                                    </div>
                                  </div>
                                  <div className={style.profile_link}>
                                    <Button onClick={() => {
                                      this.props.history.push(`/advisor-profile/${advisor.id}`)
                                    }}>مشاهده فایل ها</Button>
                                  </div>
                                </div>
                              </div>
                          )
                        })
                      }
                    </OwlCarousel>
                )
              }
            </Col>
          </Row>
        </div>
    )
  }
}


const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  fetchTopAdvisor: () => dispatch(advisorActions.fetchTopAdvisor()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Advisor));